import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as smsCampaignServices from "../../../services/smsCampaign/smsCampaign.js";

export const getCampaignInfo = createAsyncThunk(
    "smsCampaign/getInfo",
    async (payload, thunkAPI) => {
        try {
            const result = await smsCampaignServices.getCampaignInformation(payload);
            if (result?.success) return result.data || null;
            return thunkAPI.rejectWithValue(result?.message || "Something went wrong");
        } catch (err) {
            const errMsg = err?.response?.message || err?.message || "Internal Server Error!";
            return thunkAPI.rejectWithValue(errMsg);
        }
    }
);

export const getSmsCampaignDataIssueSummary = createAsyncThunk(
    "smsCampaign/getDataIssueSummary",
    async (payload, thunkAPI) => {
        try {
            const result = await smsCampaignServices.getCampaignSummary(payload);
            console.log("Result : ", result)
            if (result?.success) return result?.data ? result.data : {};
            return thunkAPI.rejectWithValue(result?.message || "Something went wrong");
        } catch (err) {
            const errMsg = err?.response?.message || err?.message || "Internal Server Error!";
            return thunkAPI.rejectWithValue(errMsg);
        }
    }
);

export const getSmsCampaignDataIssues = createAsyncThunk(
    "smsCampaign/getSmsCampaignDataIssues",
    async (body, thunkAPI) => {
        try {
            const response = await smsCampaignServices.getCampaignDataIssues(body);
            return response; // { data: [...], totalCount: number }
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error?.response?.data?.message || error.message || "Failed to load campaign data issues"
            );
        }
    }
);

export const getSmsCampaignValidContacts = createAsyncThunk(
    "smsCampaign/getSmsCampaignValidContacts",
    async (body, thunkAPI) => {
        try {
            const response = await smsCampaignServices.getSmsCampaignValidContacts(body);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error?.response?.data?.message || error.message || "Failed to load campaign data issues"
            );
        }
    }
);

const initialState = {
    campaignInfo: {
        data: null,
        loading: false,
        error: null,
    },
    dataIssueSummary: {
        summary: null,
        loading: false,
        error: null,
    },
    smsDataIssueLogs: {
        dataIssues: [],
        totalCount: 0,
        dataIssueLoading: false,
        dataIssueError: null,
        snsStatSummary: null,
    },
};

const smsCampaignSlice = createSlice({
    name: "smsCampaign",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCampaignInfo.pending, (state) => {
                state.campaignInfo.loading = true;
                state.campaignInfo.error = null;
                state.campaignInfo.data = null;
            })
            .addCase(getCampaignInfo.rejected, (state, action) => {
                state.campaignInfo.loading = false;
                state.campaignInfo.error = action.payload;
                state.campaignInfo.data = null;
            })
            .addCase(getCampaignInfo.fulfilled, (state, action) => {
                state.campaignInfo.loading = false;
                state.campaignInfo.error = null;
                state.campaignInfo.data = action.payload;
            });

        builder
            .addCase(getSmsCampaignDataIssueSummary.pending, (state) => {
                state.dataIssueSummary.loading = true;
                state.dataIssueSummary.error = null;
                state.dataIssueSummary.summary = null;
            })
            .addCase(getSmsCampaignDataIssueSummary.rejected, (state, action) => {
                state.dataIssueSummary.loading = false;
                state.dataIssueSummary.error = action.payload;
                state.dataIssueSummary.summary = null;
            })
            .addCase(getSmsCampaignDataIssueSummary.fulfilled, (state, action) => {
                state.dataIssueSummary.loading = false;
                state.dataIssueSummary.error = null;
                state.dataIssueSummary.summary = action.payload;
            });

        builder.addCase(getSmsCampaignDataIssues.pending, (state) => {
            state.smsDataIssueLogs.dataIssueLoading = true;
            state.smsDataIssueLogs.dataIssueError = null;
        })
            .addCase(getSmsCampaignDataIssues.fulfilled, (state, action) => {
                state.smsDataIssueLogs.dataIssueLoading = false;
                state.smsDataIssueLogs.dataIssues = action.payload?.data || [];
                state.smsDataIssueLogs.totalCount = action.payload?.total || 0;
            })
            .addCase(getSmsCampaignDataIssues.rejected, (state, action) => {
                state.smsDataIssueLogs.dataIssueLoading = false;
                state.smsDataIssueLogs.dataIssueError = action.payload || "Failed to load campaign data issues";
            });
    },
});

export const smsCampaignReducer = smsCampaignSlice.reducer;
